import { BillingInfo } from './types';

export const DEFAULT_EMPTY_BILLING_INFO_VALUES: BillingInfo = {
  accountName: '',
  routingNumber: '',
  accountType: '',
  accountNumber: '',
};
